<template>
  <article>
    <group gutter="0px" class="status">
      <x-input title="客户姓名" placeholder="请输姓名" v-model="customer.customer_name"></x-input>
      <cell title="联系电话" :value="getValues(customer.first_arrive_type)" v-model="customer.mobile" v-if="customer.selectAuth || id"></cell>
      <x-input v-else title="联系电话" placeholder="请输电话" v-model="customer.mobile" @input="queryByMobile()"></x-input>
    </group>
    <group title="到店信息" class="status">
      <cell v-if="id" title="首次到店类型" :value="getValues(customer.first_arrive_type)"></cell>

      <cell v-else-if="customer.selectAuth" title="首次到店类型"
            :value="getTypes(customer.first_arrive_type)"></cell>

      <selector v-else title="首次到店类型" placeholder="请选择" :options="sub_arrive_type"
                v-model="customer.first_arrive_type">
      </selector>

      <cell title="首次到店日期" :value="timeTransform(customer.first_arrive_at)"></cell>

      <selector title="意向级别" :options="intentionLevel" v-model="customer.intention_level"></selector>

      <cell title="购车意向" primary="content" class="status-left status-cell">
        <div slot="value" class="status-cell-group">
          <cell @click.native="selModels(true,index,item.car_model_id)"
                v-for="(item,index) in customer.intention_cars" :key="index"
                :title="item.car_model_name+'-'+item.inner_color_ch+'-'+item.outer_color_ch" class="car-intention"
                is-link>
          </cell>
          <cell v-if="customer.intention_cars.length < 3" @click.native="selModels(true)" title="请选择+"
                class="car-intention f-color"
                is-link>
          </cell>
        </div>
      </cell>
      <cell title="竞品车型" primary="content" class="status-left status-cell">
        <div slot="value" class="status-cell-group"><!--最多三个-->
          <cell @click.native="selModels(false,index,item.car_model_id)"
                v-for="(item,index) in customer.contrast_cars" :key="index"
                :title="item.car_model_name" class="car-intention"
                is-link>
          </cell>
          <cell v-if="customer.contrast_cars.length < 3" @click.native="selModels(false)" title="请选择+"
                class="car-intention f-color"
                is-link>
          </cell>
        </div>
      </cell>
      <x-address
        v-model="chanelList"
        show-name
        title="客户渠道"
        class="address-before"
        :list="channelData"
        placeholder="请选择"
        hideDistrict>
      </x-address>
      <x-address
        v-model="addressList"
        @on-change="handleAddress"
        title="地区来源"
        show-name
        class="address-before"
        placeholder="请选择">
      </x-address>
      <x-input title="详细地址" placeholder="街道门牌信息" v-model="customer.address"></x-input>
    </group>
    <group title="跟进记录" v-if="customer.notes && customer.notes.length>0">
      <cell class="sale-record" v-for="(item, index) in customer.notes" :key="index">
        <p slot="after-title"><span class="label">{{item.intention_level}}级</span></p>
        <p slot="after-title" class="content">{{item.remark}}</p>
        <p slot="after-title" class="time">{{item.created_at}}<span class="call-time">通话时长：{{item.call_duration}}</span>
        </p>
      </cell>
    </group>
    <group class="status">
      <cell title="建档人员" :value="customer.creator"></cell>
    </group>
    <x-dialog v-model="isShow" :hideOnBlur="true">
      <section class="tip-result">
        <i class="result-ico icon-tipico-ok"></i>
        <p class="result-hd">已提交</p>
      </section>
    </x-dialog>
    <section class="btn-bottom addfile-btn-bottom" v-if="this.id">
      <div class="btn-fix addfile-btn" v-if="authId === customer.assignee_id && followCustomerAuth">
        <a v-if="customer.status===1 || customer.status===2 || customer.status===4 " class="btn"
           href="javascript:void(0);" @click.stop="sureSubmit">确认提交</a>
        <a  v-if="customer.status===1 || customer.status===2 || customer.status===4 " class="btn" href="javascript:void(0);" @click.stop="addRecord">添加跟进记录</a>
        <a v-if="customer.status===1" class="btn" href="javascript:void(0);" @click.stop="signTheBill">确定签单</a>
        <a v-if="customer.status===1" class="btn" href="javascript:void(0);" @click.stop="applyFail">申请战败</a>
      </div>
    </section>

    <section class="btn-bottom" v-else>
      <div class="btn-fix">
        <a class="btn" href="javascript:void(0);" @click.stop="createNewCustomer">确认提交</a>
      </div>
    </section>
  </article>
</template>

<script>
import {
  XDialog,
  XAddress,
  Selector,
  XInput,
  Cell,
  Group
} from '@lx-frontend/cvux'
import cache from '../../../common/cache'
import util from '../../../common/util'
import authApi from '../../../common/auth'

export default {
  components: {
    XDialog,
    XAddress,
    Selector,
    XInput,
    Cell,
    Group
  },
  data () {
    return {
      pageAuth: [authApi.saleManage.sale_potential_customer_view_self, authApi.saleManage.sale_potential_customer_view_all],
      followCustomerAuth: false,
      id: '',
      originUrl: 'originUrl',
      localArchivesDataKey: 'customerArchivesLocalData',
      arrive_type: [],
      sub_arrive_type: [],
      channelTypeArr: [],
      subChannelTypeArr: [],
      authId: '',
      customer: {
        address: '',
        intention_cars: [],
        contrast_cars: [],
        notes: [],
        priority: '',
        user_type: '',
        intention_level: '5',
        store_visit_id: ''
      },
      car_color: [],
      intentionLevel: [],
      isShow: false,
      addressList: [],
      addressObj: {
        province_code: '',
        city_code: '',
        district_code: '',
        province: '',
        city: '',
        district: ''
      },
      channelData: [],
      chanelList: []
    }
  },
  created () {
    this.$store.state.promiseAuth.then(auth => {
      this.authId = auth.id
      let permission = authApi.haveSomeAuth(this.pageAuth, auth.authList)
      this.followCustomerAuth = auth.authList.includes(authApi.saleManage.sale_potential_customer_follow_up)
      if (permission) {
        this.$rest.saleManage.getEnums().then(res => {
          if (res.code === 0) {
            this.car_color = res.data.car_color
            this.intentionLevel = res.data.intention_level
            this.arrive_type = res.data.arrive_type
            this.channelTypeArr = res.data.channel_type
            this.subChannelTypeArr = res.data.sub_channel_type
            this.channelData = this.getChanelType(this.channelTypeArr, this.subChannelTypeArr)
            // this.chanelList = [this.channelData[0].value, this.channelData[this.channelTypeArr.length].value]
            let query = this.$route.query
            this.id = query.id
            // 自身页面数据存储
            let localData = cache.getSessionData(this.localArchivesDataKey)
            if (localData) {
              if (localData.addressList.length > 2) {
                this.addressList = localData.addressList
              }
              if (localData.chanelList.length > 0) {
                this.chanelList = localData.chanelList
              }
              this.customer = localData.customer
            } else if (this.id) {
              this.getCustomerDetail()
            }
            if (!this.customer.store_visit_id) {
              this.customer.store_visit_id = query.store_visit_id || null
            }
            if (!this.customer.creator) {
              this.customer.creator = auth.userName
            }
            // 是否编辑页面购车意向
            let modelId = query.modelId
            if (modelId) {
              this.$rest.saleManage.getAppointedCarInfo(null, modelId).then((res) => {
                if (res.code === 0) {
                  let outer = query.outer
                  let inner = query.inner
                  // 意向车型
                  if (outer && inner) {
                    let obj = {
                      car_model_id: parseInt(modelId),
                      outer_color: parseInt(outer),
                      inner_color: parseInt(inner),
                      car_model_name: res.data.model_name
                    }
                    let innerColorCh = this.car_color.find(t => {
                      return inner === t.key
                    })
                    if (innerColorCh) {
                      obj.inner_color_ch = innerColorCh.value
                    }
                    let outerColorCh = this.car_color.find(t => {
                      return outer === t.key
                    })
                    if (outerColorCh) {
                      obj.outer_color_ch = innerColorCh.value
                    }
                    // 更改/替换
                    if (localData.chooseItem) {
                      let index = localData.chooseItem.index
                      Object.assign(this.customer.intention_cars[index], obj)
                    } else {
                      // 添加
                      let intentionCarsEX = this.customer.intention_cars.findIndex(x => {
                        return x.car_model_id === parseInt(modelId)
                      })
                      if (intentionCarsEX === -1) {
                        this.customer.intention_cars.push(obj)
                      }
                    }
                  } else {
                    let obj = {
                      car_model_id: parseInt(modelId),
                      car_model_name: res.data.model_name
                    }
                    if (localData.chooseItem) {
                      let index = localData.chooseItem.index
                      Object.assign(this.customer.contrast_cars[index], obj)
                    } else {
                      let contrastCarsEX = this.customer.contrast_cars.findIndex(x => {
                        return x.model_id === parseInt(modelId)
                      })
                      if (contrastCarsEX === -1) {
                        this.customer.contrast_cars.push(obj)
                      }
                    }
                  }
                }
              })
            }
          }
        })
      } else {
        this.showToast('您尚未获得相关权限')
      }
    })
  },
  methods: {
    timeTransform (str) {
      if (!str) return ''
      let date = new Date(str.replace(/-/g, '/'))
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + month + '-' + day
    },
    getValues (type) {
      if (!type) return ''
      let target = this.arrive_type.find(v => {
        return v.key === type.toString()
      })
      if (target) {
        return target.value
      }
    },
    getTypes (fromType) {
      return fromType === '2' ? 'PU' : 'NET'
    },
    getCustomerDetail () {
      this.$rest.saleManage.arrivedCustomerInfo(null, this.id).then(res => {
        if (res.code === 0) {
          let customer = this.customer = res.data
          customer.channel_type = customer.channel_type + ''
          customer.first_arrive_type = customer.first_arrive_type + ''
          customer.intention_level = customer.intention_level + ''
          if (customer.province_code && customer.city_code && customer.district_code) {
            this.addressList = [customer.province_code, customer.city_code, customer.district_code]
          }
          if (parseInt(customer.channel_type) > 0) {
            let subChannelT = customer.sub_channel_type + ''
            let channelT = customer.channel_type
            if (channelT === '1') {
              subChannelT = `100${subChannelT}`
            } else {
              subChannelT = `${channelT}${channelT}`
            }
            this.chanelList = [channelT, subChannelT]
          } else {
            this.chanelList = []
          }
          customer.intention_cars = customer.intention_cars.map(v => {
            let innerColorCh = this.car_color.find(t => {
              return v.inner_color === parseInt(t.key)
            })
            if (innerColorCh) {
              v.inner_color_ch = innerColorCh.value
            }
            let outerColorCh = this.car_color.find(t => {
              return v.outer_color === parseInt(t.key)
            })
            if (outerColorCh) {
              v.outer_color_ch = outerColorCh.value
            }
            return v
          })
        }
      })
    },
    selModels (flag, index, editId) {
      let path = '/salemanage/staff/customerarchives'
      if (this.id) {
        path = path + '?id=' + this.id
      }
      cache.setSessionData(this.originUrl, {
        from: 'customerarchives',
        includeColor: flag,
        path: path
      })
      // 当前页面数据
      let chooseItem = null
      if (typeof index !== 'undefined' && typeof editId !== 'undefined') {
        chooseItem = { index: index, editId: editId }
      }
      cache.setSessionData(this.localArchivesDataKey, {
        customer: this.customer,
        chooseItem: chooseItem,
        addressList: this.addressList,
        chanelList: this.chanelList
      })
      if (flag) {
        this.$router.push('/salemanage/car/intendbrands')
      } else {
        this.$router.push('/salemanage/car/brands')
      }
    },
    basicTransportData () {
      let cus = this.customer
      let transport = {
        address: cus.address,
        mobile: cus.mobile,
        store_visit_id: parseInt(cus.store_visit_id),
        customer_name: cus.customer_name,
        first_arrive_type: +cus.first_arrive_type,
        first_arrive_at: cus.first_arrive_at,
        intention_cars: cus.intention_cars,
        intention_level: +cus.intention_level,
        contrast_car_ids: cus.contrast_cars.map(v => {
          return parseInt(v.car_model_id)
        })
      }
      if (this.addressList.length) {
        transport = Object.assign(this.addressObj, transport)
      }
      if (this.chanelList.length) {
        transport.channel_type = +this.chanelList[0]
        transport.sub_channel_type = cus.channel_type === '1' ? +this.chanelList[1].substring(3) : 0
      } else {
        transport.channel_type = 0
        transport.sub_channel_type = 0
      }
      return transport
    },
    createNewCustomer () {
      if (!this.id) {
        let mobile = this.customer.mobile
        if (!mobile) {
          this.showToast('请输入联系电话')
          return false
        } else if (!util.regexpMap.regexp_mobile.test(mobile)) {
          this.showToast('请输入正确的手机号')
          return false
        }
        if (!this.customer.first_arrive_type) {
          this.showToast('请选择首次到店类型')
          return false
        }

        if (!this.customer.first_arrive_at) {
          this.showToast('请选择首次到店日期')
          return false
        }
      }
      let param = this.basicTransportData()
      this.$rest.saleManage.createCustomer(param).then(res => {
        if (res.code === 0) {
          this.isShow = true
          this.$router.push({
            path: '/salemanage/staff/associatecustomer/' + res.data.id,
            query: { store_visit_id: this.customer.store_visit_id }
          })
        } else {
          this.showToast(res.message)
        }
      })
    },
    getChanelType (list, subList) {
      let listArr = []
      list.forEach(v => {
        listArr.push({
          name: v.value,
          value: v.key
        })
      })
      list.forEach(v => {
        if (v.value === '网络渠道') {
          subList.forEach(j => {
            listArr.push({
              name: j.value,
              value: `${v.key}00${j.key}`,
              parent: v.key
            })
          })
          listArr.push({
            name: '--',
            value: `${v.key}000`,
            parent: v.key
          })
        } else {
          listArr.push({
            name: '--',
            value: v.key + v.key,
            parent: v.key
          })
        }
      })
      return listArr
    },
    sureSubmit () {
      let cus = this.customer
      let transport = {
        address: cus.address,
        customer_name: cus.customer_name,
        intention_cars: cus.intention_cars,
        intention_level: +cus.intention_level,
        contrast_car_ids: cus.contrast_cars.map(v => {
          return parseInt(v.car_model_id)
        })
      }
      if (this.addressList.length) {
        transport = Object.assign(this.addressObj, transport)
      }
      if (this.chanelList.length) {
        transport.channel_type = +this.chanelList[0]
        transport.sub_channel_type = cus.channel_type === '1' ? +this.chanelList[1].substring(3) : 0
      } else {
        transport.channel_type = 0
        transport.sub_channel_type = 0
      }
      transport.id = parseInt(this.id)
      this.$rest.saleManage.updateCustomer(transport).then(res => {
        if (res.code === 0) {
          this.showToast('操作成功')
        }
      })
    },
    addRecord () {
      let cus = this.customer
      let transport = {
        address: cus.address,
        store_visit_id: cus.store_visit_id,
        customer_name: cus.customer_name,
        intention_cars: cus.intention_cars,
        intention_level: +cus.intention_level,
        contrast_car_ids: cus.contrast_cars.map(v => {
          return parseInt(v.car_model_id)
        })
      }
      if (this.addressList.length) {
        transport = Object.assign(this.addressObj, transport)
      }
      if (this.chanelList.length) {
        transport.channel_type = +this.chanelList[0]
        transport.sub_channel_type = cus.channel_type === '1' ? +this.chanelList[1].substring(3) : 0
      } else {
        transport.channel_type = 0
        transport.sub_channel_type = 0
      }
      transport.id = parseInt(this.id)
      this.$rest.saleManage.updateCustomer(transport).then(res => {
        if (res.code === 0) {
          cache.clearSessionData('addCustomerRecordLocalData')
          this.$router.push({ path: '/salemanage/staff/addcustomerrecord/' + this.id, query: { from: 'detail' } })
        }
      })
    },
    signTheBill () {
      cache.clearSessionData('sureLocalData')
      this.$router.push('/salemanage/staff/sure/' + this.id)
    },
    applyFail () {
      this.$router.push('/salemanage/staff/fail/' + this.id)
    },
    queryByMobile () {
      if (util.regexpMap.regexp_mobile.test(this.customer.mobile)) {
        this.$rest.saleManage.getCustomerInfoByMobile(null, this.customer.mobile).then(res => {
          if (res.code === 0) {
            let flag = res.data.have_defeat_or_deal_customer
            if (flag) {
              this.customer.first_arrive_type = '5'
              this.sub_arrive_type = [{ key: '5', value: 'RP' }]
            } else {
              this.customer.first_arrive_type = '1'
              this.sub_arrive_type = [{ key: '1', value: 'FU' }, { key: '4', value: 'RF' }]
            }
          }
        })
      }
    },
    /**
       * @description 处理地区来源地址数据
       * @param addressData {Object}
       */
    handleAddress(addressData) {
      this.addressObj = {
        province_code: addressData.provinceCode,
        city_code: addressData.cityCode,
        district_code: addressData.districtCode,
        province: addressData.province,
        city: addressData.city,
        district: addressData.district
      }
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
